import React, { useState, useEffect } from 'react';
import { ContainerBanner, Banner } from './Home.style.js';
import whatsapp from '../components/assets/whatsapp.png'

import apiService from '../api/home'; 

function BotaoWhatsapp({DadosAPI}) {

    return (
        <div style={{ position: 'fixed', right: '10px', bottom: '10px', zIndex: 10,  margin:10}}>
            <a target="_blank"  href={`https://wa.me/55${DadosAPI.cabecalho[0].telefone.replace(/\D/g, '')}?text=Olá,%20gostaria%20de%20mais%20informações!`}><img style={{ width: 40 }} src={whatsapp} alt="WhatsApp" /></a>
        </div>
    );
}

export default BotaoWhatsapp;
